module.exports = __webpack_public_path__ + "img/slideThree.49fffad9.svg";